// extracted by mini-css-extract-plugin
module.exports = {"coin":"styles_coin__3TDCf","skeleton-animation":"styles_skeleton-animation__m_G90"};